import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/utils/teams-app-navigation/navigate-to-teams-app';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';

export const useNavigateToTeamsApp = (
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	const { cloudId, orgId } = useSessionData();
	const { push } = useRouteActions();

	return navigateToTeamsAppBase({
		push,
		hostProduct: 'confluence',
		orgId,
		cloudId,
		userHasNav4Enabled: true,
		shouldOpenInSameTab,
		...navActionPayload,
	});
};
